import Footer from '@/components/footer/footer'
import Header from '@/components/header/header'
import evaluation from '@/components/historyEvaluation/historyEvaluation'
import NotTerminalOrders from '@/components/historyNotTerminalOrders/historyNotTerminalOrders'
import terminalOrders from '@/components/histoyTerminalOrders/histoyTerminalOrders'
import orderDetails from '@/components/historyOrderDetails/historyOrderDetails'
import { Component, Watch } from 'vue-property-decorator'
import { Getter, State, Mutation, Action } from 'vuex-class'
import BasePage from '@/views/BasePage/BasePage'
import Tracker from '@/components/tracker/tracker'
import Pagination from '@/components/pagination/pagination'
import Loading from '@/components/loading/loading'
import ModalCashbackRequest from '@/components/modalCashbackRequest/modalCashbackRequest'

@Component({
  components: {
    Footer,
    Header,
    evaluation,
    NotTerminalOrders,
    terminalOrders,
    orderDetails,
    Tracker,
    Pagination,
    Loading,
    ModalCashbackRequest
  }
})
export default class History extends BasePage {
  showView = false;
  jsonProductsSize = 0;
  answers = [];
  internationalizedState = '';
  currentPage = 1;
  isLoading = false;

  // Getters
  @Getter getCurrentOrder: any
  @Getter getNotTerminalOrders: any
  @Getter getTerminalOrders: any
  @Getter getOrders: any
  @Getter getOrdersMeta: any
  @Getter getOpenCart: any
  @Getter getOpenCashbackModal: any
  @Getter getUserValidCoupons: any
  @Getter getIsToken: any
  @Getter getOrdersWithCoupons: any

  // Mutations
  @Mutation CURRENT_ORDER: any
  @Mutation ADDONS: any
  @Mutation CANTIDAD: any
  @Mutation OPEN_CART
  @Mutation OPEN_CASHBACK_MODAL

  // Actions
  @Action action_getOrders: any
  @Action action_getUserValidCoupons: any

  getDeliveryMan() {
    if (this.getCurrentOrder.is_takeout || !this.getCurrentOrder.delivery.delivery_man) {
      return 'not name'
    } else {
      return `${this.getCurrentOrder.delivery.delivery_man.first_name} ${this.getCurrentOrder.delivery.delivery_man.last_name}`
    }
  }
  goToTrack () {
    this.$router.push({ name: 'tracker', params: { order_id: this.getCurrentOrder.id } })
  }
  createDate(date: any) {
    const dateFormatted = new Date(date)
    let minutes = dateFormatted.getMinutes()
    if (minutes < 10) {
      minutes = `0${minutes}` as any
    }
    const hour = dateFormatted.getHours()
    const created = hour > 12 ? `${(hour - 12)}:${minutes}pm` : `${(hour)}:${minutes}am`
    return `${dateFormatted.getDate()}/${dateFormatted.getMonth() + 1}/${dateFormatted.getFullYear()}
      ${created}`
  }
  backToOrders() {
    this.$router.push({ name: 'history_orders' })
  }
  setTime(date: any) {
    const dateFormatted = new Date(date)
    let minutes = dateFormatted.getMinutes()
    if (minutes < 10) {
      minutes = `0${minutes}` as any
    }
    const hour = dateFormatted.getHours()
    const createdTime = hour > 12 ? `${(hour - 12)}:${minutes}pm` : `${(hour)}:${minutes}am`
    return createdTime
  }
  setDate(date: any) {
    const dateFormatted = new Date(date)
    return `${dateFormatted.getDate()}/${dateFormatted.getMonth() + 1}/${dateFormatted.getFullYear()}`
  }
  backToCommerce() {
    this.$router.push({ name: 'city', params: { city_id: this.getCurrentOrder.commerce.id } })
  }

  created() {
    this.OPEN_CART(false);
  }

  async mounted() {
    const paymentFailed = this.$route.query.payment_failed;
    if(paymentFailed && paymentFailed === 'true') {
      this.$swal({
        title: "¡Advertencia!",
        text: "No pudimos procesar tu último pago así" + 
              " que hemos generado un link de pagos para que puedas completar tu orden."
      })
    }
    try {
      this.isLoading = true;
      const queryPage = this.$route.query.page;
      await this.action_getOrders();
      if (this.getIsToken) {
        await this.action_getUserValidCoupons();
      }
      if (queryPage && queryPage.length) {
        this.onRouteQueryChange();
      } else {
        this.goToDefaultPage();
      }
    } catch (error) {
      this.$swal({
        title: 'Error',
        text: 'Error al cargar las órdenes'
      });
      this.goToDefaultPage();
    }
    this.setPageTitle();
    this.isLoading = false;
  }

  setPageTitle() {
    if (window && window.document && window.document.title) {
      window.document.title = `Historia pedidos - TodosComemos`;
    }
  }

  get getHeader() {
    const name = this.$route.name
    return name !== 'checkout'
  }

  get isDrawerOpen() {
    let response = false;
    if(this.getIsXLScreen || this.getCurrentOrder) {
      response = true;
    }
    return response;
  }

  onDrawerClose() {
    this.CURRENT_ORDER({});
    this.OPEN_CART(false);
  }

  onSelectOrder(order) {
    this.CURRENT_ORDER(order);
    this.OPEN_CART(true);
  }

  @Watch('$route.query', { deep: true })
  async onRouteQueryChange() {
    this.isLoading = true;
    try {
      let pageNumber = parseInt(this.$route.query.page as string);
      if(pageNumber && pageNumber >= 1 && pageNumber <= this.getOrdersMeta.total_pages) {
        const payload = {
          perPage: 5,
          page: pageNumber
        };
        await this.action_getOrders(payload);
        this.currentPage = pageNumber;
        if(this.getOrders && this.getOrders.length && this.getOrders[0]) {
          this.CURRENT_ORDER({});
        }
      } else {
        this.goToDefaultPage();
      }
    } catch (error) {
      this.$swal({
        title: "¡Error!",
        text: "Error al cargar la página"
      });
      this.goToDefaultPage();
    }
    this.isLoading = false;
  }

  goToDefaultPage() {
    this.$router.replace({ query: {
      page: "1"
    }});
  }

  _goToPage(pageNumber) {
    if(this.$route.query && this.$route.query.page && this.$route.query.page !== pageNumber) {
      this.$router.replace({ query: {
        page: pageNumber
      }});
    }
  }

  _toggleModalCashback(open) {
    this.OPEN_CASHBACK_MODAL(open);
  }
}
